
import { TranslatableKey } from '../messages/messages';
import { useIntl } from 'react-intl';
import { useCallback } from 'react';

type IdType = {
    id : TranslatableKey
}
export type fromUseTypedIntlInterface = (arg: IdType, values?: Record<string, string | number>) => string
export type translateFromUseTypedIntlInterface = (key: TranslatableKey) => string
export default function useTypedIntl(){
    const { formatMessage:f } = useIntl();

    const translate = useCallback((key: TranslatableKey) => f({id: key}),[f])
    const translateOptions = useCallback((options:{label:TranslatableKey, value:any}[])=>{
        return options.map(({label,value}) => {
            return {
                value,
                label:translate(label)
            }
        })
    },[translate]);
    return { translate, f, translateOptions };
}